var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgImage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0846146c-283e-43e2-ada8-7781cf93a3da",
    "data-name": "Layer 2",
    viewBox: "0 0 24.98 17.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8 {\n        opacity: .56;\n      }\n\n      .uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8, .uuid-97681e4c-b877-45c2-b96e-a9868f0936a7 {\n        fill: #f7931e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-666f7cff-38a1-45c4-b2d1-ad4a7b7bb629",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-97681e4c-b877-45c2-b96e-a9868f0936a7",
    d: "M17.24,17.46H1.88c-1.43,0-2.33-1.53-1.65-2.78L7.41,1.53c.69-1.26,2.49-1.32,3.25-.09l8.18,13.15c.78,1.25-.12,2.87-1.6,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8",
    d: "M23.1,17.46h-6.29c-1.44,0-2.34-1.54-1.64-2.8l3.22-5.76c.73-1.3,2.6-1.28,3.3,.03l3.07,5.76c.67,1.25-.24,2.76-1.66,2.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-97681e4c-b877-45c2-b96e-a9868f0936a7",
    cx: 17.91,
    cy: 2.45,
    r: 2.45
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image.afa8646f.svg";
export { ForwardRef as ReactComponent };